// Environment configuration
// This file provides type-safe access to environment variables

const env = {
  // Get the current environment from VITE_APP_ENV or default to 'development'
  // This should be set in your .env files or build process
  // Example: VITE_APP_ENV=staging
  NODE_ENV: import.meta.env.MODE,
  APP_ENV: import.meta.env.VITE_APP_ENV || 'development',
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development',

  // Check if current environment matches the given environment
  is: (envName: string) => env.environment === envName,

  // Helper methods for specific environments
  isDevelopment: () => env.environment === 'development',
  isStaging: () => env.environment === 'staging',
  isProduction: () => env.environment === 'production',
  isDemo: () => env.environment === 'demo',
}

export default env
